// set var css
(function () {
    function readHeights() {
        const h = {};
        h.windowHeight = window.innerHeight;
        h.announcementHeight = getHeight("#shopify-section-announcement-bar");
        h.headerHeight = getHeight("#shopify-section-header sticky-header");
        return h;
    }

    function setVarsOnResize() {
        setVars();
        window.addEventListener("resize", setVars);
        window.addEventListener("scroll", setVars);
    }

    function setVars() {
        const { windowHeight, announcementHeight, headerHeight } = readHeights();
        document.documentElement.style.setProperty("--full-height", `${windowHeight}px`);
        document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`);
        document.documentElement.style.setProperty("--height-fixed-header", `${headerHeight}px`);
        document.documentElement.style.setProperty("--content-full", `${windowHeight - headerHeight}px`);
    }

    function getHeight(selector) {
        const el = document.querySelector(selector);
        return el ? el.clientHeight : 0;
    }

    document.addEventListener("DOMContentLoaded", function () {
        setVarsOnResize();
    });
})();

const isSmoothScrollSupported = () => {
    return "scrollBehavior" in document.documentElement.style || (window.CSS && CSS.supports("scroll-behavior", "smooth"));
};
function smoothScroll(targetPosition, duration) {
    let startPosition = window.pageYOffset;
    let distance = targetPosition - startPosition;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        let timeElapsed = currentTime - startTime;
        let run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
    }

    function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
}

async function prqAddedAllToCartCallback(event) {
    let myCartItems = [];
    let myCartItemsToNumber = [];
    myCartItems = [...event.variantId.split('||')];
    myCartItemsToNumber = myCartItems.map(item => Number(item));
    if (event.action === 'add_all') {
        const cartData = await quizGetCartData();
        const cartItems = cartData.items;
        const discountedItems = cartItems.filter(item => myCartItemsToNumber.includes(item.variant_id));
        const discountedItemsKey = await discountedItems.map(item => item.key)
        console.log(discountedItems);
        const addedItems = [];

        discountedItems.forEach(item => {
            addedItems.push({
                id: item.variant_id,
                quantity: item.quantity,
                properties: {
                    "_bundle_discount": discountedItems.length,
                    // "bundle_count": discountedItems.length
                }
            });
        })

        const deletedItems = discountedItemsKey.reduce((acc, cur) => {
            acc[cur] = 0;
            return acc;
        }, {});

        let formData = {
            items: addedItems
        }

        quizUpdateCart(deletedItems)

        fetch('/cart/clear.js').then(
            setTimeout(() => {
                addBackDiscountedItems(formData)
            }, 300)
        )        
    }
}

function quizGetCartData() {
    return fetch("/cart.js")
        .then((response) => {
            return response.text();
        }).then(state => {
            return JSON.parse(state)
        })
}

function quizUpdateCart(data) {
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
        updates: data
    })    
}

function addBackDiscountedItems(formData) {
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(response => {
            return response.json();
        })
        .catch((error) => {
            console.error('Error:', error);
        });
}